import * as React from "react";

import {
  getDocRangeSelection,
  areEqualRangeSelections,
  setDocSelection,
} from "../../src/selection";

interface DocInlineTextProps {
  content: InlineHtmlContent;
  contentKey: string;
  editState: EditState;
  preventEditing?: boolean;
  uid: string;
}

export default function DocInlineText(props: DocInlineTextProps)  {
  const {
    content,
    contentKey,
    editState,
    preventEditing,
    uid,
  } = props;

  if (editState.isEditor && editState.isEditing && !preventEditing) {
    return (
      <DocInlineEditableText
        content={content}
        contentKey={contentKey}
        editState={editState}
        preventEditing={preventEditing}
        uid={uid}
      />
    );
  } else {
    return (
      <span
        className="doc-inline-text mousetrap"
        data-uid={uid}
        data-contentkey={contentKey}
        dangerouslySetInnerHTML={{__html: content || ""}}
      />
    );
  }
}

interface DocInlineEditableTextProps {
  content: InlineHtmlContent;
  contentKey: string;
  editState: EditStateTrue;
  preventEditing?: boolean;
  uid: string;
}

interface DocInlineEditableTextState {}
class DocInlineEditableText extends React.Component<DocInlineEditableTextProps, DocInlineEditableTextState>  {
  constructor(props: DocInlineEditableTextProps) {
    super(props);
    this.ref = React.createRef();
  }

  private ref: React.RefObject<HTMLSpanElement>;

  isEditingByProps(props: DocInlineEditableTextProps) {
    const currentlyEditing = props.editState.currentlyEditing;
    return currentlyEditing && currentlyEditing.uid === props.uid && currentlyEditing.key === props.contentKey; // TODO: INSPECT && !currentlyEditing.selectionMenu
  }

  updateSelectionIfRelevantByProps(props: DocInlineEditableTextProps, shouldDelay=false) {
    const currentlyEditing = props.editState.currentlyEditing;

    if (currentlyEditing && this.isEditingByProps(props)) {
      const currentDocRangeSelection = getDocRangeSelection();
      if (currentDocRangeSelection && !areEqualRangeSelections(currentDocRangeSelection, currentlyEditing)) {
        const setDocSelctionFunc = () => setDocSelection(currentlyEditing);
        if (shouldDelay) {
          setTimeout(setDocSelctionFunc, 10);
        } else {
          setDocSelctionFunc();
        }
      }
    }
  }

  shouldComponentUpdate(nextProps: DocInlineEditableTextProps, nextState: DocInlineEditableTextState) {
    const shouldUpdate =
      this.props.content != nextProps.content ||
      this.isEditingByProps(this.props) != this.isEditingByProps(nextProps) ||
      this.props.editState.isEditing !== nextProps.editState.isEditing;

    if (!shouldUpdate) { this.updateSelectionIfRelevantByProps(nextProps, true); }

    return shouldUpdate;
  }

  componentDidUpdate(prevProps: DocInlineEditableTextProps, prevState: DocInlineEditableTextState) {
    this.updateSelectionIfRelevantByProps(this.props);
  }

  componentDidMount() {
    this.updateSelectionIfRelevantByProps(this.props);
  }

  setAsCurrentlyEditing() {
    this.props.editState.setCurrentlyEditing({uid: this.props.uid, range: {start: 0, end: 0}, key: this.props.contentKey});
  }

  render() {
    let content = this.props.content;
    if (content.length === 0) {
      if (!this.isEditingByProps(this.props)) {
        return (
          <span
            className="doc-inline-text insert-text-here"
            onClick={this.setAsCurrentlyEditing.bind(this)}
          >Insert Text Here
          </span>
        );
      } else {
        content = "&nbsp;";
      }
    }

    return (
      <span
        className="doc-inline-text mousetrap"
        data-uid={this.props.uid}
        data-contentkey={this.props.contentKey}
        dangerouslySetInnerHTML={{__html: content}}
        contentEditable
        autoCapitalize="off"
        // autoComplete={"off"} // TODO: ADD BACK IN?
        autoCorrect="off"
        spellCheck={false}
        onClick={(e) => e.stopPropagation()}
        ref={this.ref}
      />
    );
  }
}
